var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trainers-list trainers-list-scrollable"},[_c('transition-group',{staticClass:"trainersCardsWrapper",attrs:{"name":"animated-list","tag":"div"}},_vm._l((_vm.bookmarksList),function([key, value]){return _c('TrainerCard',{key:key,attrs:{"trainer":value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }